/* eslint-disable @typescript-eslint/no-explicit-any */
import { Control, Controller } from 'react-hook-form';
import { FormSectionTitle } from './styles/common.styled';
import { Field } from '@fluentui/react-components';
import { defaultDatePickerStrings, DayOfWeek } from '@fluentui/react';
import {
  DatePickerContainer,
  DatePickerStyle,
} from 'src/components/Tickets/common/styles/common.styled';
import { useState } from 'react';
import { singlePubSub, singlePubSubConst } from 'src/pub-sub/pub-sub';

interface FormDatePickerProps {
  controlName: string;
  control: Control<any>;
}

export const FormDatePicker = ({
  control,
  controlName,
}: FormDatePickerProps) => {
  const [date, setDate] = useState<Date>();

  return (
    <>
      <FormSectionTitle>Request due date</FormSectionTitle>
      <Field>
        <Controller
          name={controlName}
          control={control}
          render={({ field: { onChange, value } }) => (
            <DatePickerContainer>
              <DatePickerStyle
                onSelectDate={(d) => {
                  const setValue = () => {
                    setDate(d);
                    onChange(d);
                  };

                  const resetValue = () => {
                    setDate(undefined);
                    onChange(undefined);
                  };

                  singlePubSub.subscribe(
                    singlePubSubConst.RESET_DATE_PICKER,
                    resetValue
                  );

                  setValue();
                }}
                value={value}
                today={date}
                placeholder="Select date"
                strings={defaultDatePickerStrings}
                minDate={new Date()}
                showGoToToday={false}
                isMonthPickerVisible={false}
                firstDayOfWeek={DayOfWeek.Monday}
              />
            </DatePickerContainer>
          )}
        />
      </Field>
    </>
  );
};
